import superagent from 'superagent';
import querystring from 'querystring';

const API = '/api';
const TIMEOUT = 5000;

const pendingRequests = {};

function abortPendingRequests(resource) {
    if (pendingRequests[resource]) {
        pendingRequests[resource]._callback = () => {};
        pendingRequests[resource].abort();
        delete pendingRequests[resource];
    }
}

export const requestData = (pathname, params, pushState) => {
    const resource = pathname;
    abortPendingRequests(resource);
    return new Promise((resolve, reject) => {
        const qs = querystring.stringify(params);
        const pageUrl = resource + (qs ? `?${qs}` : '');
        const apiUrl = API + pageUrl;
        pendingRequests[resource] = superagent
            .get(apiUrl)
            .timeout(TIMEOUT)
            .end((error, response) => {
                if (error) {
                    return reject(error);
                }
                if (pushState && typeof window !== 'undefined') {
                    window.history.pushState(params, null, pageUrl);
                }
                return resolve(response.body);
            });
    });
};

const requestResource = (request, resource, data, meta) => {
    abortPendingRequests(resource);
    return new Promise((resolve, reject) => {
        let payload;
        if (data || meta) {
            payload = { data, meta };
        }
        pendingRequests[resource] = request(API + resource)
            .send(payload)
            .timeout(TIMEOUT)
            .end((error, response) => {
                if (error) {
                    return reject(error);
                }
                return resolve(response.body);
            });
    });
};

const wrapper = (method, dispatch, resource, data, meta, action, args) => {
    dispatch(action('REQUEST', ...args));
    return requestResource(method, resource, data, meta)
        .then(result => {
            dispatch(action('SUCCESS', ...args, result));
        })
        .catch(error => {
            dispatch(action('FAILURE', ...args, error));
        });
};

export const addResource = (dispatch, resource, data, meta, action, args) =>
    wrapper(superagent.post, dispatch, resource, data, meta, action, args);

export const getResource = (dispatch, resource, action, args) => wrapper(superagent.get, dispatch, resource, null, null, action, args);

export const updateResource = (dispatch, resource, data, meta, action, args) =>
    wrapper(superagent.put, dispatch, resource, data, meta, action, args);

export const deleteResource = (dispatch, resource, action, args) => wrapper(superagent.del, dispatch, resource, null, null, action, args);



// WEBPACK FOOTER //
// ./src/actions/async.js